import { supabase } from '@/integrations/supabase/client';

export const normalizePermissions = (keys: string[]) => Array.from(new Set(keys));

export const hasPermission = (permissions: string[], perm: string) => {
  return permissions.includes('*') || permissions.includes(perm);
};

export const fetchEffectivePermissions = async (orgId: string, userId?: string) => {
  const authUser = (await supabase.auth.getUser()).data.user ?? null;
  const resolvedUserId = userId ?? authUser?.id ?? null;
  if (!resolvedUserId) return [];

  const { data, error } = await (supabase as any).rpc('get_org_effective_permissions', {
    p_org_id: orgId,
    p_user_id: resolvedUserId,
  });
  if (error) throw error;
  return normalizePermissions((data || []) as string[]);
};
